import {
  Switch,
  Route,
  withRouter,
  Redirect
} from "react-router-dom"

import Esigning from './containers/Esigning'
import Home from './containers/Home'

const EsignRouter = ({ location }) => {
  return (
    <Switch>
      <Route path="/confirmation/:encodedIdentity" component={ Esigning }/> 
      <Route path="/appointment/:encodedIdentity" component={ Esigning }/> 
      <Route path="/authorisation/:encodedIdentity" component={ Esigning }/> 
      <Route path="/refund/:encodedIdentity" component={ Esigning }/> 
      <Route path="/home" component={ Home }/> 
      <Redirect from={ '/' } to={ '/home' } />
    </Switch>
  )
}

export default withRouter( EsignRouter )